import React from 'react';

const EmailCloudTeeth = () => {
  return (
    <svg
      width="257"
      height="32"
      viewBox="0 0 257 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M34.3846 29.5C28.6634 29.5 23.9615 24.7904 23.9615 18.9867V2.5H44.8077V18.9867C44.8077 24.7904 40.1058 29.5 34.3846 29.5Z"
        fill="white"
        stroke="black"
        strokeWidth="5"
      />
      <path
        d="M76.3846 29.5C70.6634 29.5 65.9615 24.7904 65.9615 18.9867V2.5H86.8077V18.9867C86.8077 24.7904 82.1058 29.5 76.3846 29.5Z"
        fill="white"
        stroke="black"
        strokeWidth="5"
      />
      <path
        d="M118.385 29.5C112.663 29.5 107.962 24.7904 107.962 18.9867V2.5H128.808V18.9867C128.808 24.7904 124.106 29.5 118.385 29.5Z"
        fill="white"
        stroke="black"
        strokeWidth="5"
      />
      <path
        d="M160.385 29.5C154.663 29.5 149.962 24.7904 149.962 18.9867V2.5H170.808V18.9867C170.808 24.7904 166.106 29.5 160.385 29.5Z"
        fill="white"
        stroke="black"
        strokeWidth="5"
      />
      <path
        d="M202.385 29.5C196.663 29.5 191.962 24.7904 191.962 18.9867V2.5H212.808V18.9867C212.808 24.7904 208.106 29.5 202.385 29.5Z"
        fill="white"
        stroke="black"
        strokeWidth="5"
      />
      <path
        d="M243.923 29.5C238.202 29.5 233.5 24.7904 233.5 18.9867V2.5H254.346V18.9867C254.346 24.7904 249.644 29.5 243.923 29.5Z"
        fill="white"
        stroke="black"
        strokeWidth="5"
      />
      <path
        d="M12.9231 29.5C7.20188 29.5 2.5 24.7904 2.5 18.9867V2.5H23.3462V18.9867C23.3462 24.7904 18.6443 29.5 12.9231 29.5Z"
        fill="white"
        stroke="black"
        strokeWidth="5"
      />
      <path
        d="M54.9231 29.5C49.2019 29.5 44.5 24.7904 44.5 18.9867V2.5H65.3462V18.9867C65.3462 24.7904 60.6443 29.5 54.9231 29.5Z"
        fill="white"
        stroke="black"
        strokeWidth="5"
      />
      <path
        d="M96.9231 29.5C91.2019 29.5 86.5 24.7904 86.5 18.9867V2.5H107.346V18.9867C107.346 24.7904 102.644 29.5 96.9231 29.5Z"
        fill="white"
        stroke="black"
        strokeWidth="5"
      />
      <path
        d="M138.923 29.5C133.202 29.5 128.5 24.7904 128.5 18.9867V2.5H149.346V18.9867C149.346 24.7904 144.644 29.5 138.923 29.5Z"
        fill="white"
        stroke="black"
        strokeWidth="5"
      />
      <path
        d="M180.923 29.5C175.202 29.5 170.5 24.7904 170.5 18.9867V2.5H191.346V18.9867C191.346 24.7904 186.644 29.5 180.923 29.5Z"
        fill="white"
        stroke="black"
        strokeWidth="5"
      />
      <path
        d="M222.923 29.5C217.202 29.5 212.5 24.7904 212.5 18.9867V2.5H233.346V18.9867C233.346 24.7904 228.644 29.5 222.923 29.5Z"
        fill="white"
        stroke="black"
        strokeWidth="5"
      />
    </svg>
  );
};

export default EmailCloudTeeth;
